<div class="header-left">
  <div class="logo">
    <img
      class="xp-icon"
      alt="Xpotential icon"
      src="assets/icons/xpotential-icon.svg"
    />
    <div class="name">AI Sales Coach</div>
  </div>
</div>
<div class="header-right">
  <div class="menu">
    <a
      class="item"
      [ngClass]="{ active: this.currentPage === 'HOME' }"
      [routerLink]="['/home']"
      >ホーム</a
    >
    @if (hasMember() || canSeeMemberInfo()) {
      <a
        class="item"
        [ngClass]="{ active: this.currentPage === 'USER_LIST' }"
        [routerLink]="['/users']"
        >メンバー</a
      >
    }
    @if (canSeeRoleplay()) {
      <button
        class="item"
        [matMenuTriggerFor]="roleplayMenu"
        [ngClass]="{ active: this.currentPage === 'ROLEPLAY' }"
      >
        ロールプレイ
      </button>
    }
    <mat-menu #roleplayMenu="matMenu">
      @if (isEnablerOrAdmin()) {
        <a class="sub-menu-item" [routerLink]="['/roleplay', 'persona', 'list']"
          >ペルソナ一覧</a
        >
      }
      <a class="sub-menu-item" [routerLink]="['/roleplay', 'session']">
        セッション開始</a
      >
    </mat-menu>
    @if (canSeeKpiDashboards()) {
      <a
        class="item"
        [ngClass]="{ active: this.currentPage === 'KPI_DASHBOARD' }"
        [routerLink]="['/kpi-dashboards']"
        >個人支援ボード</a
      >
    }
    <button
      class="item"
      [matMenuTriggerFor]="assessmentMenu"
      [ngClass]="{ active: this.currentPage === 'ASSESSMENTS' }"
    >
      アセスメント
    </button>
    <mat-menu #assessmentMenu="matMenu">
      <a class="sub-menu-item" [routerLink]="['/assessments']"
        >アセスメント一覧</a
      >
      @if (isEnablerOrAdmin()) {
        <a
          class="sub-menu-item"
          [routerLink]="['/assessments', 'bulk-execution']"
          >{{
            isEvaluationSkipped() ? '一括アップロード' : 'アセスメント一括実行'
          }}</a
        >
      }
      @if (canSeeMeetingRecording()) {
        <a
          class="sub-menu-item"
          [routerLink]="['/assessments', 'meeting-recording']"
          >商談録音</a
        >
      }
    </mat-menu>
    <button
      class="item"
      [matMenuTriggerFor]="dashboardMenu"
      [ngClass]="{ active: this.currentPage === 'DASHBOARD' }"
    >
      分析
    </button>
    <mat-menu #dashboardMenu="matMenu">
      <a class="sub-menu-item" [routerLink]="['/dashboard', 'individual']"
        >個人</a
      >
      @if (this.isEnablerOrAdmin()) {
        <a class="sub-menu-item" [routerLink]="['/dashboard', 'organization']"
          >組織</a
        >
      }
    </mat-menu>
    @if (isEnablerOrAdmin()) {
      <button
        class="item"
        [matMenuTriggerFor]="adminMenu"
        [ngClass]="{ active: this.currentPage === 'ADMIN' }"
      >
        組織設定
      </button>
    }
    <mat-menu #adminMenu="matMenu">
      <a class="sub-menu-item" [routerLink]="['/admin', 'users']"
        >ユーザー管理</a
      >
      <a class="sub-menu-item" [routerLink]="['/admin', 'license-usage']"
        >利用状況</a
      >
      @if (this.isAdmin()) {
        <a class="sub-menu-item" [routerLink]="['/admin', 'organization']"
          >組織管理</a
        >
      }
      @if (isAssessmentSettingsVisible()) {
        <a
          class="sub-menu-item"
          [routerLink]="['/admin', 'assessment-settings']"
          >アセスメント設定</a
        >
      }
      <a class="sub-menu-item" [routerLink]="['/admin', 'external-integration']"
        >外部連携</a
      >
    </mat-menu>
  </div>
  <div class="user-wrapper">
    <div class="user">
      <div class="name">{{ user?.name }}</div>
      <div class="department">{{ user?.departmentName }}</div>
    </div>
    <button
      class="icon-button"
      aria-label="ユーザーメニュー"
      [matMenuTriggerFor]="userMenu"
    >
      <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
    <mat-menu #userMenu="matMenu">
      <a class="sub-menu-item" [routerLink]="['/settings', 'security']"
        >個人設定</a
      >
      <button class="sub-menu-item" (click)="logout()">ログアウト</button>
    </mat-menu>
  </div>
</div>
